import { Command } from "@ckeditor/ckeditor5-core";

export default class ShowBlocksCommand extends Command {
  execute(value) {
    const editor = this.editor;

    editor.fire("cde:setShowBlocks", value);
  }

  refresh() {
    this.isEnabled = true;
    this.value = !!this.editor.showBlocks;
  }
}
